module.exports = __webpack_public_path__ + "img/L07.8d7965f0.jpg";